const fieldLibrary = {
  title: "Field Library",
  fields: "Fields",
  templates: "Templates",
  styles: "Styles",
  search: "Search fields...",
  noResults: "No fields found",
  expandPanel: "Expand to side panel",
  categoryText: "Text",
  categorySelection: "Selection",
  categoryTime: "Time",
  configTitle: "Field Settings",
  label: "Label",
  placeholder: "Placeholder",
  required: "Required",
  maxLength: "Max Length",
  defaultValue: "Default Value",
  defaultChecked: "Default Checked",
  options: "Options",
  addOption: "Add option",
  maxSelections: "Max Selections",
  format: "Format",
  allowCustomTags: "Allow Custom Tags",
  maxTags: "Max Tags",
  addTag: "Add tag",
  save: "Save",
  cancel: "Cancel",
  saving: "Saving...",
  soon: "Soon",
  existingFields: "Existing Fields",
  createNew: "New Field",
  usageCount: "Uses",
  usedIn: "Used in:",
  noDefinitions: "No fields defined yet. Create one in the \"New Field\" tab.",
  insertField: "Insert Field",
  editDefinition: "Edit Definition",
  deleteDefinition: "Delete Field",
  confirmDelete: "Are you sure? This field is used in {count} documents.",
  lastEdited: "Last edited",
  dropdownMode: "Dropdown",
  floatingMode: "Floating",
  loading: "⏳ Loading...",
} as const;
export default fieldLibrary;
